import { CommonEnvMultiSelect } from '../CommonFields';

const prodEnvironmentsSuggestions = ['SPT', 'PRD'];

interface ProdEnvironmentsPropType {
  value: string[];
  fieldError: boolean;
  errorText?: string;
  onChangeHandler: (event: React.ChangeEvent<{}>, value: string[]) => void;
  onBlurHandler: (event: React.FocusEvent<HTMLInputElement>) => void;
}

const ProdEnvironments = (props: ProdEnvironmentsPropType) => {
  const { value, fieldError, errorText, onChangeHandler, onBlurHandler } =
    props;

  return (
    <CommonEnvMultiSelect
      componentID="prodEnvironments"
      label="Production Environments"
      data={prodEnvironmentsSuggestions}
      value={value}
      onChangeHandler={onChangeHandler}
      onBlurHandler={onBlurHandler}
      fieldError={fieldError}
      helperText={
        fieldError && errorText
          ? errorText
          : 'Select from the list or enter a custom environment name (3 ASCII alphabet characters) and hit the Enter key to add it to the list.'
      }
      fullHelpText="Production environments to be built. You can have up to 3 production environments. Each environment name must be 3 ASCII alphabet characters."
    />
  );
};

ProdEnvironments.defaultProps = {
  errorText: undefined,
};

export default ProdEnvironments;
